import { useQuery } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function useSession() {
  const trpc = useTRPC()
  return useQuery(trpc.me.queryOptions(undefined, { staleTime: 5 * 60_000 }))
}

export type AppConfig = {
  microsoftSignIn: boolean
  devAuthBypass: boolean
  /** False when the server has no RESTORE_PASSCODE, which turns restoring off. */
  restoreEnabled: boolean
}

export function useAppConfig() {
  return useQuery({
    queryKey: ['app-config'],
    queryFn: async (): Promise<AppConfig> => {
      const response = await fetch('/api/config')
      if (!response.ok) throw new Error('The server is not reachable.')
      return (await response.json()) as AppConfig
    },
    staleTime: Infinity,
    retry: 10,
    retryDelay: (attempt) => Math.min(500 * 2 ** attempt, 5_000)
  })
}
